/** Стиль-пак «tech-mint» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'tech-mint',
  shape: {
    radiusCard: 24, radiusOption: 16, radiusButton: 'pill', radiusImage: 16,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 56, optionPadY: 16, optionPadX: 20, gap: 12, contentMaxWidth: 520, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 32, h1Weight: 700, h1Tracking: 0,
    qSize: 26, qWeight: 700, qTracking: 0, optionSize: 16, optionWeight: 500,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: true, backButton: 'icon-circle', logo: 'center' },
  cta: { placement: 'inline', fullWidth: false, height: 48, disabledStyle: 'muted-brand' },
  states: { selected: 'filled', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'icon-circle', overlayTone: 'brand', frame: 'rounded',
    promptHint: 'flat tech illustration, two-color, clean geometry, no photo',
  },
  // Clario: тёмная карточка-акцент держит середину светлой страницы.
  // Иллюстрации плоские и двухцветные — вуаль им не нужна.
  layout: { alignY: 'center', alignX: 'center', backgroundOverlay: 'none' },
  // Clario: язык пака — сканер. Кольцо с процентом плюс карточки того, что
  // «просканировано», то есть ответов пользователя.
  loader: {
    style: 'ring', showPercent: true, socialProof: 'review',
    answersSummary: true, engagementModals: true,
  },
  // Clario: продуктовая подача — моно-отсчёт в шапке как системный элемент,
  // скидка плоской плашкой, помесячная цена, чип на рамке тёмной карточки,
  // невыбранные гаснут на светлой странице. Sticky-CTA обязателен.
  paywall: {
    timer: 'mono-header', promoTicket: 'plain', priceMode: 'per-month',
    planHighlight: 'chip-on-border', dimUnselectedPlans: true,
    stickyHeader: true, repeatPurchaseBlock: false,
  },
  // Мятный бренд и «зелёный успеха» — соседи, поэтому премиальность отдана
  // бренду, а деньги остаются на success-переменной.
  accents: { money: 'success', premium: 'brand' },
};
